import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { User } from '@/entities/User/types/user';
import { EPercentileGroup } from '../../enums';
import type { Ileader } from '../../types/ILeader';
interface UseGroupedLeadersByRankProps {
  dataList?: Ileader[];
  user: User | null;
}
export interface LeaderWithFlag extends Ileader {
  currentUser: boolean;
}
export interface UseGroupedLeadersByRankResult {
  groups: Record<EPercentileGroup, LeaderWithFlag[]>;
  currentUserFromNoTop: LeaderWithFlag | null;
}
export const useGroupedLeadersyRank = t0 => {
  const $ = _c(10);
  const {
    dataList,
    user
  } = t0;
  user?.id;
  let t1;
  bb0: {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = [];
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = [];
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = [];
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = [];
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = [];
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        [EPercentileGroup.TOP_10]: t2,
        [EPercentileGroup.TOP_20]: t3,
        [EPercentileGroup.TOP_30]: t4,
        [EPercentileGroup.TOP_40]: t5,
        [EPercentileGroup.TOP_50]: t6,
        [EPercentileGroup.NO_TOP]: []
      };
      $[5] = t7;
    } else {
      t7 = $[5];
    }
    const empty = t7;
    if (!dataList || dataList.length === 0) {
      let t8;
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
          groups: empty,
          currentUserFromNoTop: null
        };
        $[6] = t8;
      } else {
        t8 = $[6];
      }
      t1 = t8;
      break bb0;
    }
    const currentUserId = user?.id ?? null;
    let t8;
    if ($[7] !== currentUserId || $[8] !== dataList) {
      const groups = {
        [EPercentileGroup.TOP_10]: [],
        [EPercentileGroup.TOP_20]: [],
        [EPercentileGroup.TOP_30]: [],
        [EPercentileGroup.TOP_40]: [],
        [EPercentileGroup.TOP_50]: [],
        [EPercentileGroup.NO_TOP]: []
      };
      let currentUserFromNoTop = null;
      for (const leader of dataList) {
        const isCurrent = currentUserId !== null && leader.userId === currentUserId;
        const originalGroup = leader.percentileGroup;
        if (originalGroup === EPercentileGroup.NO_TOP && !isCurrent) {
          continue;
        }
        const leaderForRender = {
          ...leader,
          percentileGroup: leader.percentileGroup,
          currentUser: isCurrent
        };
        if (isCurrent && originalGroup === EPercentileGroup.NO_TOP) {
          currentUserFromNoTop = leaderForRender;
          continue;
        }
        groups[originalGroup].push(leaderForRender);
      }
      t8 = {
        groups,
        currentUserFromNoTop
      };
      $[7] = currentUserId;
      $[8] = dataList;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    t1 = t8;
  }
  const result = t1;
  return result;
};